import React from 'react';
import { HashRouter as Router, Redirect } from 'react-router-dom';
import Login from './Login';
import Header from './Header';

import { Container, Image, Col, Row, Button } from 'react-bootstrap';
import { isAuthenticated } from '../../utils/authentication';


export const AppTitle = "Tuner4TRONIC";

export default class App extends React.Component {

    onHelp() {

        let url = `${window.location.origin}/docu/index.html`;
        if (process.env.NODE_ENV !== 'production') {
            url = `http://dev.tuner4tronic.com/docu/index.html`;
        }

        var win = window.open(url, '_blank');
        win.focus();
    }

    render() {

        document.title = AppTitle;

        if (isAuthenticated()) {
            return (<Redirect to='/' />);
        }

        return (
            <Router>
                <div>
                    <Header />
                </div>
                <div className="content">
                    <Container fluid="true" className="internal-content">
                        <Row style={{ height: '90vh' }}>
                            <Col sm={2} ></Col>
                            <Col sm={4} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} >
                                <Login />
                            </Col>
                            <Col sm={1} ></Col>
                            <Col sm={4} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} >
                                <div style={{ maxWidth: '90vh' }}>
                                    <Row>
                                        <Col>
                                            <Image src="./images/T4T.png" style={{ maxWidth: '50%', height: 'auto' }} />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col style={{ maxWidth: '50%', height: 'auto' }}>
                                            <div className="minimuSystemRequirements">
                                                Minimum system requirements: Google Chrome or Mozilla Firefox
                                                <br />
                                                (We do not recommend Internet Explorer)
                                                <br />
                                                Minimum screen resolution: 1366x768px
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col style={{ maxWidth: '50%', height: 'auto', textAlign: 'center' }}>
                                            <br />
                                            <Button variant="secondary" type="button" onClick={this.onHelp}>
                                                Help
                                            </Button>
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                            <Col sm={1} ></Col>
                        </Row>
                        <Row style={{ height: '4vh' }}>
                            <Col sm={10} style={{ display: 'flex', alignItems: 'center' }}>
                            <div className="loginFooter" style={{ paddingLeft: '25px' }}>&copy;{( new Date().getFullYear() )}, INVENTRONICS GmbH. All rights reserved. </div>
                                <a rel="noopener noreferrer" className="loginFooter" href={`${window.location.protocol}//${window.location.hostname}/imprint.html`} target="_blank" style={{ paddingLeft: '25px' }}>Imprint</a>
                                <a rel="noopener noreferrer" className="loginFooter" href={`${window.location.protocol}//${window.location.hostname}/terms.html`} target="_blank" style={{ paddingLeft: '25px' }}>Terms of Use</a>
                                <a rel="noopener noreferrer" className="loginFooter" href={`${window.location.protocol}//${window.location.hostname}/privacy.html`} target="_blank" style={{ paddingLeft: '25px' }}>Privacy Policy</a>
                                <a rel="noopener noreferrer" className="loginFooter" href={`${window.location.protocol}//${window.location.hostname}/oss.html`} target="_blank" style={{ paddingLeft: '25px' }}>Open Source Licenses</a>
                                <a rel="noopener noreferrer" className="loginFooter" href="https://www.inventronics-light.com/contact-us" target="_blank" style={{ paddingLeft: '25px' }}>Contacts</a>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </Router>
        );
    }
}

